module.exports = __webpack_public_path__ + "img/93.b4b77b35.png";